import { useContext } from 'react';
import { axiosClient } from "../../library/Service/axiosClient";


const FormListService = () => {

    // Get the all user based on the search filters
    async function allForms(instituteValue, programId = null) {
        console.log(instituteValue, 'instituteValue all users')
        try {
            const userObj = JSON.parse(localStorage.getItem('user') || '{}');
            const isSuperAdminUser = userObj?.role === 'SUPER_ADMIN' || userObj?.userTypeCode === 'SUPER_ADMIN';
            const instituteGroupId = isSuperAdminUser
                ? (localStorage.getItem('widgetGroup') || '')
                : (userObj?.instituteGroupId || '');
            const queryParts = [];
            if (instituteGroupId) queryParts.push(`instituteGroupId=${instituteGroupId}`);
            if (programId) queryParts.push(`programId=${programId}`);
            const groupQry = queryParts.length ? `?${queryParts.join('&')}` : '';
            let usersData = await axiosClient().get(`${process.env.REACT_APP_WIDGET_API_SERVER}/widgetInfo/getFormList/${instituteValue}${groupQry}`);

            console.log(usersData?.data, 'markersData data list')
    
            // Ensure markersData?.data is an array and transform if necessary.
            // Coerce null/undefined institute_id to '' so group-level forms (institute_id IS NULL
            // in DB) match the SelectControl's strict parent filter when the user clears the
            // institute dropdown — at which point parentData becomes '' (the placeholder value),
            // and `null == ''` is false but `'' == ''` matches.
            return usersData?.data?.map((item) => ({
                code: item.widget_inst_id,
                value: item.widget_name,
                category_code: "FORM_WITH_INSTITUTE",
                parentCode: item.institute_id ?? instituteValue,
                display_order: 1,
                flex_col: {},
                is_active: 1,
            })) || [];
        } catch (error) {
            console.error('Error fetching all users:', error);
            return []; // Return an empty array in case of error
        }
    }

    return {
        allForms
    };

};

export default FormListService;